module.exports = __webpack_public_path__ + "static/media/coffeecup.310d8f45.jpg";